/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_Row_Linear_NoteInputs */

const en_mk_calc_row_linear_note = /** @type {(inputs: Mk_Calc_Row_Linear_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US$16 per seat. AI credits are bought separately up front, minimum US$10.`)
};

const id_mk_calc_row_linear_note = /** @type {(inputs: Mk_Calc_Row_Linear_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US$16 per kursi. Kredit AI dibeli terpisah di muka, minimum US$10.`)
};

/**
* | output |
* | --- |
* | "US$16 per seat. AI credits are bought separately up front, minimum US$10." |
*
* @param {Mk_Calc_Row_Linear_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_row_linear_note = /** @type {((inputs?: Mk_Calc_Row_Linear_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Row_Linear_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_row_linear_note(inputs)
	return en_mk_calc_row_linear_note(inputs)
});